import { render, staticRenderFns } from "./TextBuilder.vue?vue&type=template&id=25453d1d&scoped=true"
import script from "./TextBuilder.vue?vue&type=script&lang=js"
export * from "./TextBuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25453d1d",
  null
  
)

export default component.exports